export const useAdminPage = ['/admin-panel/rsr', '/admin-panel/psr'].some((url) =>
  window.location.pathname.includes(url),
);
